import { QueryClient, useQuery } from '@tanstack/react-query';

import { axiosForAnonymousHudson } from '@telialt/utils/src/axios/axiosForAnonymousHudson';

import { API } from '../api';
import { QUERY_KEYS } from '../constants';
import { MaintenanceResponseData } from '../model';

const apiGetMaintenanceData = () => axiosForAnonymousHudson.get<MaintenanceResponseData>(API.MAINTENANCE);

export const useMaintenanceData = () => {
    return useQuery<MaintenanceResponseData>({
        queryKey: [QUERY_KEYS.MAINTENANCE],
        queryFn: async () => (await apiGetMaintenanceData()).data,
    });
};

export const prefetchMaintenanceData = (queryClient: QueryClient) => {
    return queryClient.fetchQuery({
        queryKey: [QUERY_KEYS.MAINTENANCE],
        queryFn: async () => (await apiGetMaintenanceData()).data,
    });
};
